const AVATAR_COLORS = [
  'bg-red-500', 'bg-orange-500', 'bg-amber-500', 'bg-yellow-500', 
  'bg-lime-500', 'bg-green-500', 'bg-emerald-500', 'bg-teal-500', 
  'bg-cyan-500', 'bg-sky-500', 'bg-blue-500', 'bg-indigo-500', 
  'bg-violet-500', 'bg-purple-500', 'bg-fuchsia-500', 'bg-pink-500', 'bg-rose-500'
];

// Returns { className, style } - use className for Tailwind colors, style for custom hex
export const getAvatarColor = (user) => {
  // If user has a saved primary_color, use it
  if (user?.primary_color) {
    return { className: '', style: { backgroundColor: user.primary_color } };
  }
  
  // Fall back to hash-based random color
  const str = user?.email || `${user?.firstname || ''}${user?.lastname || ''}` || 'U';
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return { className: AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length], style: {} };
};

export const getInitials = (user) => {
  const first = (user?.firstname || '')[0] || '';
  const last = (user?.lastname || '')[0] || '';
  return (first + last).toUpperCase() || (user?.email || 'U')[0].toUpperCase();
};
